var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7273 0H2.09091C1.53654 0.000553544 1.00503 0.221023 0.613025 0.613024C0.221023 1.00503 0.000553544 1.53654 0 2.09091V20.9091C0.000553544 21.4635 0.221023 21.995 0.613025 22.387C1.00503 22.779 1.53654 22.9994 2.09091 23H16.7273C17.2816 22.9994 17.8131 22.7789 18.2051 22.3869C18.5971 21.9949 18.8175 21.4634 18.8182 20.9091V2.09091C18.8175 1.53656 18.5971 1.0051 18.2051 0.613113C17.8131 0.221129 17.2816 0.000633642 16.7273 0ZM2.09091 20.9091V2.09091H16.7273L16.7283 20.9091H2.09091Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10.4546C23 10.1773 22.8899 9.91141 22.6938 9.71535C22.4978 9.51929 22.2318 9.40914 21.9546 9.40914C21.6773 9.40914 21.4114 9.51929 21.2153 9.71535C21.0193 9.91141 20.9091 10.1773 20.9091 10.4546V24.0455C20.9088 24.3227 20.7986 24.5884 20.6026 24.7844C20.4066 24.9804 20.1409 25.0907 19.8637 25.091H6.27275C5.99548 25.091 5.72957 25.2011 5.53351 25.3972C5.33744 25.5932 5.2273 25.8591 5.2273 26.1364C5.2273 26.4137 5.33744 26.6796 5.53351 26.8757C5.72957 27.0717 5.99548 27.1819 6.27275 27.1819H19.8637C20.6952 27.181 21.4924 26.8502 22.0804 26.2622C22.6684 25.6743 22.9991 24.877 23 24.0455V10.4546Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBtn);
export default __webpack_public_path__ + "static/media/copy_btn.ba845cd44e1d8325c86cbbf7ebddbf12.svg";
export { ForwardRef as ReactComponent };